import React, { PureComponent } from 'react'
import track from 'react-tracking'
import PropTypes from 'prop-types'
import { reduxForm, formValues, Field as ReduxFormField } from 'redux-form'
import Field from '@ynap/field'
import { SimpleAsyncButton } from '@ynap/button'
import Notification from '@ynap/notification'
import validate from './validate'
import collateErrors from './collateErrors'
import { Link } from 'react-router-dom'
import { PasswordInput } from '@ynap/password-input'
import { onSubmitFail, submitAndCollateErrorsPromise } from '@ynap/form-utils'
import BEMHelper from '@ynap/bem-helper'
import { Panel } from '@ynap/login-and-registration-form'
import LoginConsent from '@ynap/login-and-registration-form/src/LoginForm/LoginConsent'
import { trackResetPasswordSubmit } from '../analytics'
import { myaccountPageData } from '../../analytics'
import { withOptimizely } from '@ynap/optimizely-utils'
import { SubmissionError } from 'redux-form'

const bem = new BEMHelper('ResetPasswordForm')

@track()
export class ResetPasswordForm extends PureComponent {
    static propTypes = {
        form: PropTypes.string,
        messages: PropTypes.shape({
            resetPasswordForm: PropTypes.shape({
                title: PropTypes.func.isRequired,
                createPassword: PropTypes.func.isRequired,
                submit: PropTypes.func.isRequired,
                resetSuccess: PropTypes.func.isRequired,
                continue: PropTypes.func.isRequired,
                confirmation: PropTypes.func.isRequired,
            }).isRequired,
            errors: PropTypes.shape({
                global: PropTypes.func.isRequired,
            }).isRequired,
        }).isRequired,
        className: PropTypes.string,
        error: PropTypes.string,
        login: PropTypes.func.isRequired,
        handleSubmit: PropTypes.func.isRequired,
        onSubmit: PropTypes.func.isRequired,
        submitSucceeded: PropTypes.bool,
        submitting: PropTypes.bool,
        locale: PropTypes.shape({
            id: PropTypes.string,
        }).isRequired,
    }

    constructor() {
        super()
    }

    @track(
        myaccountPageData({
            name: 'reset password',
            type: 'reset password',
        })
    )
    componentDidMount() {}

    @track((props, state, methodArgs, promiseArgs) => {
        const { optimizely } = props

        const err = promiseArgs[1]

        if (!err) {
            optimizely?.track('account_updatedpassword')
        }

        return trackResetPasswordSubmit(props)
    })
    submitAndCollateErrorsWithDelay = async (values) => {
        const { onSubmit, login, loginRedirect, locale } = this.props
        const promise = onSubmit(values, 450, loginRedirect)

        try {
            if (values && !values?.externalConsentsProvided) {
                await submitAndCollateErrorsPromise(promise, values, this.props)
            }
            if (loginRedirect) {
                await login(values, 'login', 450, loginRedirect === 'home' ? `/${locale.id}/` : `/${locale.id}/account`)
            }
        } catch (error) {
            let json
            try {
                json = await error.response.json()
            } catch (_) {
                throw error
            }
            throw new SubmissionError(collateErrors(values, this.props, json))
        }
    }

    render() {
        const {
            form,
            messages,
            className,
            error,
            handleSubmit,
            submitSucceeded,
            locale,
            children,
            submitting,
            loginRedirect,
        } = this.props

        return !submitSucceeded || loginRedirect ? (
            <Panel title={messages.resetPasswordForm.title()}>
                <form
                    id={form}
                    className={bem(null, null, className)}
                    onSubmit={handleSubmit(this.submitAndCollateErrorsWithDelay)}
                >
                    <div className={bem('fieldsWrapper')}>
                        <Field
                            name="logonId"
                            type="email"
                            label={messages.resetPasswordForm.logonId()}
                            autoComplete="username"
                        />
                        <Field
                            component={PasswordInput}
                            name="logonPassword"
                            label={messages.resetPasswordForm.createPassword()}
                        />
                    </div>
                    <div className={bem('buttonWrapper')}>
                        <SimpleAsyncButton
                            className={bem('submit')}
                            loading={submitting}
                            copy={messages.resetPasswordForm.submit()}
                        />
                    </div>
                    <ReduxFormField
                        className={bem('field')}
                        component={LoginConsent}
                        name="externalConsentsProvided"
                        messages={messages}
                    />
                    {error ? <Notification className={bem('error')} message={error} type="error" /> : null}
                    {children}
                </form>
            </Panel>
        ) : (
            <Panel>
                <div className={bem(null, null, className)}>
                    <div className={bem('image')} />
                    {messages.resetPasswordForm.confirmation && (
                        <div className={bem('confirmation')}>{messages.resetPasswordForm.confirmation()}</div>
                    )}
                    <div className={bem('resetSuccess')}>{messages.resetPasswordForm.resetSuccess()}</div>
                    <Link className={bem('continue')} to={`/${locale.id}/account/login`}>
                        {messages.resetPasswordForm.continue()}
                    </Link>
                </div>
            </Panel>
        )
    }
}

const ResetPasswordFormWithValues = formValues('logonId')(ResetPasswordForm)
export default withOptimizely(
    reduxForm({ form: 'resetPasswordForm', validate, collateErrors, onSubmitFail })(ResetPasswordFormWithValues)
)
